import {
  EmbeddedViewRef,
  Renderer2,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';

/** Renders a template under `document.body` so fixed overlays escape overflow/transform ancestors. */
export class BodyPortal {
  private host: HTMLElement | null = null;
  private view: EmbeddedViewRef<unknown> | null = null;

  constructor(
    private readonly vcr: ViewContainerRef,
    private readonly renderer: Renderer2,
    private readonly document: Document,
  ) {}

  attach(template: TemplateRef<unknown>): void {
    this.detach();
    this.host = this.renderer.createElement('div');
    this.renderer.addClass(this.host, 'tc-body-portal');
    this.view = this.vcr.createEmbeddedView(template);
    for (const node of this.view.rootNodes) {
      this.renderer.appendChild(this.host, node);
    }
    this.renderer.appendChild(this.document.body, this.host);
    this.view.detectChanges();
  }

  detach(): void {
    this.view?.destroy();
    this.view = null;
    if (this.host) {
      this.renderer.removeChild(this.document.body, this.host);
      this.host = null;
    }
  }

  contains(target: EventTarget | null): boolean {
    return (
      target instanceof Node &&
      this.host !== null &&
      this.host.contains(target)
    );
  }

  querySelector<E extends Element = Element>(selector: string): E | null {
    return (this.host?.querySelector(selector) as E | null) ?? null;
  }
}
